import { useEffect } from "react";
import { assertPreventKey, preventDefaultKey, validateViewTag } from "./validate";
import { validateCallback } from "../validateCallback";
import { missingNativeBuild } from "../nativeError";
var ScreenCapture = Object.freeze({
  getState: function getState() {
    return Promise.resolve("unspecified");
  },
  captureWindow: function captureWindow() {
    return Promise.reject(missingNativeBuild("ScreenCapture.captureWindow"));
  },
  captureView: function captureView(viewTag) {
    validateViewTag(viewTag);
    return Promise.reject(missingNativeBuild("ScreenCapture.captureView"));
  },
  addStateListener: function addStateListener(onChange) {
    validateCallback(onChange, "ScreenCapture.addStateListener requires a function");
    return function() {
    };
  },
  addScreenshotListener: function addScreenshotListener(onScreenshot) {
    validateCallback(onScreenshot, "ScreenCapture.addScreenshotListener requires a function");
    return function() {
    };
  },
  prevent: function prevent() {
    var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : preventDefaultKey;
    assertPreventKey(key, "prevent");
    return Promise.resolve();
  },
  allow: function allow() {
    var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : preventDefaultKey;
    assertPreventKey(key, "allow");
    return Promise.resolve();
  },
  isPrevented: function isPrevented() {
    return Promise.resolve(false);
  }
});
function usePreventScreenCapture() {
  var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : preventDefaultKey;
  assertPreventKey(key, "prevent");
  useEffect(function() {
  }, [
    key
  ]);
}
export {
  ScreenCapture,
  usePreventScreenCapture
};
//# sourceMappingURL=unavailable.js.map
